import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import {SettingsContext} from '../components/userSettingsContext';
import { useState, useEffect, useContext, forwardRef, useImperativeHandle, useRef  } from "react"

import {CcStepper2, StepperNavButtons} from "../commonComponents/stepper"
import { IconButton, Dialog, DialogActions, FormGroup, FormControlLabel, Radio, Typography  } from '@mui/material';
import { CcActionButton, CcTitle, CcSubSectionTitle } from "../commonComponents/styledTexts";
import {ExclamationCircleIcon } from '@heroicons/react/20/solid'


import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import dayjs from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import axios from 'axios';

import {CcLoader, InfoToolTip, LionLoaderGradient} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'
import {CcCheckbox, InputNumber, InputText, InputURL, FileSelector, LionCombo, LionListbox} from '../commonComponents/inputFields'


import { Icon as Iconify } from '@iconify/react';

import { getErrorListFromYupError, getErrorMessage, getErrorMessageForArray, snippetDataValidationSchemaMemoryCards, webPageSettingsValidationSchemaMemoryCards } from '../components/helperErrors'
import { ccColorTeal, ccColorDarkTeal } from '../components/helpersStyles';
import {LionColorPicker, LionMultiColorPicker}  from '../components/lionColorPicker';
import { lionIcons } from '../components/helpersIcons';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { GoogleFontsSelector } from '../commonComponents/helperGoogleFonts';
import Konva from 'konva';
import { GetImageSize } from '../components/helpers';
import { PropaneRounded } from '@mui/icons-material';


const countImages = (imgs) => {
    let result = 0
    for (const img of imgs) {
        if (img.tagId === undefined) {
            if (img.imgB64.length > 0) result +=1
        }
        else {
          if (img.snippetTypeId === 1) result += img.numImages
          else result +=1
        }
    }
    return result
}


export const MemoryCardsEmailManager = forwardRef((props, ref) => {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: we don't have an onChange here because it would be to heavy to calculate the pointer png for every input change
            instead the parent can call the "askPointerImg" method to get the latest pointer png when needed
  
  askPointerImg: exposed method to call by the parent to get the pointer image
  */

  const {settings, setSettings} = useContext(SettingsContext);

  const [snippetSettings, setSnippetSettings] = useState({emailEffectType: 'static'})

  const canvasRef = useRef(null);
  const [canvasWidth, setCanvasWidth] = useState(0) //only used for the UI
  const [canvasHeight, setCanvasHeight] = useState(0) //only used for the UI

  const [openResizeDialog, setOpenResizeDialog] = useState(false);
  const [openResizeDialogData, setOpenResizeDialogData] = useState({});

  useEffect(() => {
    if (props.noRender) return
    if (props.snippetInfo) {
      //console.log(props.snippetInfo)

      const numCardsOrDefault = props.snippetInfo.snippetSettings.numCardsInEmailEffectImg === undefined || props.snippetInfo.snippetSettings.numCardsInEmailEffectImg === 0 ? countImages(props.snippetInfo.snippetSettings.cardImages)*2 : props.snippetInfo.snippetSettings.numCardsInEmailEffectImg
      setSnippetSettings({...props.snippetInfo.snippetSettings, numCardsInEmailEffectImg: numCardsOrDefault})
      initKonva()

    }

  }, [props.templateId, props.snippetInfo, settings])




  useImperativeHandle(ref, () => ({
    async askImage(imgSize) {
      const stage = new Konva.Stage({
          container: 'game',
          width: imgSize.width,
          height: imgSize.height
      });
      const layer = new Konva.Layer();
      stage.add(layer);

      //all unflipped cards
      const cards = clearCardImages()
      await drawKonvaFrame(cards, stage)
      const result = stage.toDataURL();
      return result;
    },
    async askFrames(imgSize) {
      const result = []

      //console.log(imgSize)
      //const wrapper = document.getElementById("game-wrapper");
      const stage = new Konva.Stage({
          container: 'game',
          //width: wrapper.clientWidth,
          //height: wrapper.clientHeight
          width: imgSize.width,
          height: imgSize.height
      });
      const layer = new Konva.Layer();
      stage.add(layer);

      //1st frame is all unflipped cards
      const cards = clearCardImages()
      await drawKonvaFrame(cards, stage)
      result.push(stage.toDataURL());

      const numImages = countImages(props.snippetInfo.snippetSettings.cardImages)
      const numCards = Math.min(numImages * 2, props.snippetInfo.snippetSettings.numCardsInEmailEffectImg)
      const indexesPos = uniqueRandomInts(2, numCards)
      const indexesImg = uniqueRandomInts(2, numImages)

      for (let ii = 0; ii< indexesPos.length; ii+=1) {
        const currentPos = indexesPos[ii]
        const currentImg = Math.min(indexesImg[ii], props.snippetInfo.snippetSettings.cardImages.length-1) //simple safeguard. some tags can have more than 1 image. The "const numImages" here can be bigger 
        const data = clearCardImages()

        if (props.snippetInfo.snippetSettings.cardImages[currentImg].tagId && props.snippetInfo.snippetSettings.cardImages[currentImg].tagId > 0)
          data[currentPos] = props.snippetInfo.snippetSettings.cardImages[currentImg].srcPreview
        else
          data[currentPos] = props.snippetInfo.snippetSettings.cardImages[currentImg].imgB64


        await drawKonvaFrame(data, stage)
        layer.draw()
        result.push(stage.toDataURL());
      }

      console.log(result)
      return result;
    },
  }))
  const clearCardImages = () => {
    //returns an array with unflipped card images
    const result = []
    const numImages = countImages(props.snippetInfo.snippetSettings.cardImages)
    const numCards = Math.min(numImages * 2, props.snippetInfo.snippetSettings.numCardsInEmailEffectImg)

    const cardColor = getTemplatePropValue('card-bg-color')
    const cardImage = getTemplatePropValue('card-bg-image')

    for (let i=0; i<numCards; i+=1) {
      result.push((cardImage != null && cardImage.length > 0) ? cardImage : cardColor)
    }

    return result
  }

  
  const getCanvasImg = async () => {
    //if (canvasRef.current == null) return null
    const img = canvasRef.current.toDataURL()

    return img;
  }

  function uniqueRandomInts(count, max) {
  if (count > max) {
    throw new Error("count cannot be greater than max when values must be unique.");
  }

  const numbers = new Set();

  while (numbers.size < count) {
    numbers.add(Math.floor(Math.random() * max));
  }

  return [...numbers];
  }


const handleChangeSnippetSettings = (propName, propValue) => {
  const newSettings = {...snippetSettings, [propName]: propValue}
  setSnippetSettings(newSettings)

  if (props.onChange) props.onChange(newSettings);
}

const handleStaticImageChange = (dataUrl) => {
  handleChangeSnippetSettings('emailEffectStaticImg', dataUrl)
}
const handleStaticCustomBackgroundImageChange = async (dataUrl) => {
  const size = await GetImageSize(dataUrl)
  const sizeDifferent = (size.width !== canvasWidth || size.height !== canvasHeight)
  if (sizeDifferent) {
    setOpenResizeDialogData(size)
    setOpenResizeDialog(true)
  }

  handleChangeSnippetSettings('emailEffectCustomBackground', dataUrl)
}

const getTemplatePropValue = (propName) => {
    //retrieve the prop value (give its name) from the templatePropValuesCollection
    const matchedProp = props.snippetInfo.webPageSettings.templatePropValuesCollection.find(pv => pv.propName === propName);
    
    return matchedProp.propValue;
    
  }
  // ---------- start konva section --------------------------
  const initKonva = () => {
    const wrapper = document.getElementById("game-wrapper");
    const stage = new Konva.Stage({
        container: 'game',
        //width: wrapper.clientWidth,
        //height: wrapper.clientHeight
        width: props.snippetInfo.snippetSettings.emailEffectImgSize.width,
        height: props.snippetInfo.snippetSettings.emailEffectImgSize.height,
    });
    canvasRef.current = stage;
    const layer = new Konva.Layer();
    stage.add(layer);
    //drawKonvaBackground()
    setCanvasWidth(wrapper.clientWidth)
    setCanvasHeight(wrapper.clientHeight)

    const cardColor = getTemplatePropValue('card-bg-color')
    const cardImage = getTemplatePropValue('card-bg-image')
    const numImages = countImages(props.snippetInfo.snippetSettings.cardImages)
    const numCards = Math.min(numImages * 2, props.snippetInfo.snippetSettings.numCardsInEmailEffectImg)
    
    const data = [];
    for (let i=0; i<numCards; i+=1) {
      data.push((cardImage != null && cardImage.length > 0) ? cardImage : cardColor)
    }
    //drawGrid(data, stage);



    const observer = new ResizeObserver(async() => {

			//we don't want to bubble up this every time
			//so we only bubble up when the user stopped dragging for FINISHED_DELAY ms
			const FINISHED_DELAY = 150;
			clearTimeout(observer.resizeTimeout);
      layer.destroyChildren();
      stage.width(wrapper.clientWidth);
      stage.height(wrapper.clientHeight);
      setCanvasWidth(wrapper.clientWidth)
      setCanvasHeight(wrapper.clientHeight)

      observer.resizeTimeout = setTimeout(async() => {
				//if we are here we stopped dragging
				await drawKonvaBackground();
				drawGrid(data, stage);
				if (props.onCanvasSizeChange) props.onCanvasSizeChange({width: wrapper.clientWidth, height: wrapper.clientHeight})
			}, FINISHED_DELAY);

			//if we are here we are still dragging
			//const layer = stage.getLayers()[0]
			const draggingBackground = new Konva.Rect({
				x: 0,
				y: 0,
				width: stage.width(),
				height: stage.height(),
				fill: '#aaa'
			})
		layer.add(draggingBackground)
      
    });
    observer.observe(wrapper);


  }
  const drawKonvaBackground = async (_stage) => {
    let stage = canvasRef.current
    if (_stage) stage = _stage

    if (stage == null) return
    const layer = stage.getLayers()[0]
    const backgroundRect = new Konva.Rect({
      x: 0,
      y: 0,
      width: stage.width(),
      height: stage.height(),
      fill: getTemplatePropValue('game-bg-color')
    })
		if (props.snippetInfo.snippetSettings.emailEffectCustomBackground) {
			const bgImage = await konvaAddImage(props.snippetInfo.snippetSettings.emailEffectCustomBackground, 0, 0, stage.width(), stage.height())
			layer.add(bgImage)
		}
    else layer.add(backgroundRect)
  }
  function drawGrid(items, stage) {
    //const layer = new Konva.Layer();
    //stage.add(layer);
    const layer = stage.getLayers()[0]

    const cellSize = { width: 190, height: 190 / 5 * 6 };
    const padding = 10; // space between cells

    const stageWidth = stage.width();
    const columns = Math.max(
      1,
      Math.floor((stageWidth + padding) / (cellSize.width + padding))
    );

    const availableColumns = Math.min(columns, items.length)
    const maxCardsWidth = cellSize.width * availableColumns + padding * (availableColumns + 1)
    const xOffset = (stageWidth - maxCardsWidth) / 2
    
    items.forEach((item, index) => {
      const col = index % columns;
      const row = Math.floor(index / columns);

      const x = col * (cellSize.width + padding) + padding + xOffset;
      const y = row * (cellSize.height + padding) + padding;

      // Detect if string is a data URL
      const isDataURL = item.startsWith("data:image");

      // If color → draw filled rect
      if (!isDataURL) {
        const rect = new Konva.Rect({
          x,
          y,
          width: cellSize.width,
          height: cellSize.height,
          fill: item, // treat string as a color
          stroke: "black",
          strokeWidth: 1,
          cornerRadius: 10,
        });
        layer.add(rect);
      } else {
/*
        const container = new Konva.Group({
          x: x,
          y: y,
          clipFunc: function (ctx) {
              const r = 10;
              const w = cellSize.width;
              const h = cellSize.height

              ctx.beginPath();
              ctx.moveTo(r, 0);
              ctx.arcTo(w, 0, w, h, r);
              ctx.arcTo(w, h, 0, h, r);
              ctx.arcTo(0, h, 0, 0, r);
              ctx.arcTo(0, 0, w, 0, r);
              ctx.closePath();
            }          
        });
        layer.add(container);
*/
        // Image → load into rect
        const imageObj = new Image();
        imageObj.onload = () => {
          const scale = Math.max(cellSize.width / imageObj.width, cellSize.height / imageObj.height);
          imageObj.width = imageObj.width * scale;
          imageObj.height = imageObj.height * scale;
          const konvaImage = new Konva.Image({
            x,
            y,
            width: cellSize.width,
            height: cellSize.height,
            //width: imageObj.width * scale,
            //height: imageObj.height * scale,
            image: imageObj,
            cornerRadius: 10,
          });
          //konvaImage.x((cellSize.width - konvaImage.width()) / 2);
          //konvaImage.y((cellSize.height - konvaImage.height()) / 2);
          //container.add(konvaImage);
          layer.add(konvaImage);
          layer.draw();
        };
        imageObj.crossOrigin = 'anonymous';
        imageObj.src = appendCacheBurstParam(item);
      }
    });

    layer.draw();
  }
  function drawGridAwaitable_OLD(items, stage) {
    //const layer = new Konva.Layer();
    //stage.add(layer);
    const layer = stage.getLayers()[0]

    const cellSize = { width: 190, height: 190 / 5 * 6 };
    const padding = 10; // space between cells

    const stageWidth = stage.width();
    const columns = Math.max(
      1,
      Math.floor((stageWidth + padding) / (cellSize.width + padding))
    );

    const availableColumns = Math.min(columns, items.length)
    const maxCardsWidth = cellSize.width * availableColumns + padding * (availableColumns + 1)
    const xOffset = (stageWidth - maxCardsWidth) / 2
    
    const imagePromises = items.map((item, index) => {
      return new Promise((resolve, reject) => {
      const col = index % columns;
      const row = Math.floor(index / columns);

      const x = col * (cellSize.width + padding) + padding + xOffset;
      const y = row * (cellSize.height + padding) + padding;

      // Detect if string is a data URL
      const isDataURL = item.startsWith("data:image") || item.startsWith("http");
      

      // If color → draw filled rect
      if (!isDataURL) {
        const rect = new Konva.Rect({
          x,
          y,
          width: cellSize.width,
          height: cellSize.height,
          fill: item, // treat string as a color
          stroke: "black",
          strokeWidth: 1,
          cornerRadius: 10,
        });
        layer.add(rect);
        resolve('ok')
      } else {
/*
        const container = new Konva.Group({
          x: x,
          y: y,
          clipFunc: function (ctx) {
              const r = 10;
              const w = cellSize.width;
              const h = cellSize.height

              ctx.beginPath();
              ctx.moveTo(r, 0);
              ctx.arcTo(w, 0, w, h, r);
              ctx.arcTo(w, h, 0, h, r);
              ctx.arcTo(0, h, 0, 0, r);
              ctx.arcTo(0, 0, w, 0, r);
              ctx.closePath();
            }          
        });
        layer.add(container);
*/
        // Image → load into rect
        const imageObj = new Image();
        imageObj.onload = () => {
          const scale = Math.max(cellSize.width / imageObj.width, cellSize.height / imageObj.height);
          imageObj.width = imageObj.width * scale;
          imageObj.height = imageObj.height * scale;
          const konvaImage = new Konva.Image({
            x,
            y,
            width: cellSize.width,
            height: cellSize.height,
            //width: imageObj.width * scale,
            //height: imageObj.height * scale,
            image: imageObj,
            cornerRadius: 10,
          });
          //konvaImage.x((cellSize.width - konvaImage.width()) / 2);
          //konvaImage.y((cellSize.height - konvaImage.height()) / 2);
          //container.add(konvaImage);
          layer.add(konvaImage);
          layer.draw();
          resolve('ok')
        };
        imageObj.onerror = () => {console.log('onerror'); reject(new Error("Failed to load "));}
        imageObj.crossOrigin = 'anonymous';
        imageObj.src = appendCacheBurstParam(item);
      }
    });

    //layer.draw();
    })

    return Promise.all(imagePromises);
}
  async function drawGridAwaitable(items, stage) {
    //const layer = new Konva.Layer();
    //stage.add(layer);
    const layer = stage.getLayers()[0]

    const cellSize = { width: 190, height: 190 / 5 * 6 };
    const padding = 10; // space between cells

    const stageWidth = stage.width();
    const columns = Math.max(
      1,
      Math.floor((stageWidth + padding) / (cellSize.width + padding))
    );

    const availableColumns = Math.min(columns, items.length)
    const maxCardsWidth = cellSize.width * availableColumns + padding * (availableColumns + 1)
    const xOffset = (stageWidth - maxCardsWidth) / 2
    
    let index = 0
    for (const item of items) {
      const col = index % columns;
      const row = Math.floor(index / columns);

      const x = col * (cellSize.width + padding) + padding + xOffset;
      const y = row * (cellSize.height + padding) + padding;

      // Detect if string is a data URL
      const isDataURL = item.startsWith("data:image") || item.startsWith("http");
      

      // If color → draw filled rect
      if (!isDataURL) {
        const rect = new Konva.Rect({
          x,
          y,
          width: cellSize.width,
          height: cellSize.height,
          fill: item, // treat string as a color
          stroke: "black",
          strokeWidth: 1,
          cornerRadius: 10,
        });
        layer.add(rect);
      } else {
        // Image → load into rect
        const konvaImage = await konvaAddImage(item, x, y, cellSize.width, cellSize.height)
        layer.add(konvaImage);

      }
    
    index += 1
    //layer.draw();
    }
    layer.draw();

    //return Promise.all(imagePromises);
}

  const drawKonvaFrame = async (customData, stage) => {
    //const stage = canvasRef.current;
    if (stage == null) return
    const layer = stage.getLayers()[0]
    layer.destroyChildren();

    await drawKonvaBackground(stage)
    const debug = await drawGridAwaitable(customData, stage)

  }
const konvaAddImage = (imgSrc, x, y, width, height) => {

      return new Promise((resolve, reject) => {
        const imageObj = new Image();
        imageObj.crossOrigin = 'anonymous';

        imageObj.onload = function () {
          const konvaImage = new Konva.Image({
            x: x,
            y: y,
            image: imageObj,
            width: width,
            height: height,
          });

          resolve(konvaImage)
          //wheel.add(konvaImage);
          //rotateTextInGroupAroundPoint(konvaImage, sliceAngle * i, wheelSettings.centerX, wheelSettings.centerY)

          //layer.draw();
        };
        imageObj.onerror = () => {reject()}
        imageObj.src = appendCacheBurstParam(imgSrc)

      })

}  

  // ---------- end konva sections ---------------------------

  const handleCloseResizeDialog = (resize) => {
		if (resize === true) {
	    const wrapper = document.getElementById("game-wrapper");
			wrapper.style.width = `${openResizeDialogData.width}px`
			wrapper.style.height = `${openResizeDialogData.height}px`
		}
    setOpenResizeDialog(false)
    setOpenResizeDialogData({})
  }

  const appendCacheBurstParam = (url) => {
    if (url.startsWith('http')) {
      if (url.includes('?')) return `${url}&t=${Date.now()}`
      else return `${url}?t=${Date.now()}`
    }
    else return url; //dataUrl here
  }

  if (props.noRender) return <>
              <div id='game-wrapper' className='hidden relative overflow-auto w-[600px] h-[400px] border-2 border-gray-600'>
                  <div id='game' ref={canvasRef} className='w-full h-full'></div>          
              </div>
</>

  return <div className='text-ccColorDarkTeal p-2 flex flex-col gap-y-2'>
    <CcSubSectionTitle>What you see in the email</CcSubSectionTitle>
    <div class="inline-flex rounded-md shadow-sm font-poppins" role="group">
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${snippetSettings.emailEffectType === 'static' ? 'bg-gray-200' : 'bg-white'}`}
            onClick={()=>handleChangeSnippetSettings('emailEffectType', 'static')}>
        <div>
          Static Image
        </div>
        <div className='text-sm mt-2 font-normal'>Upload your own image. </div>
      </div>
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border-t border-b border-gray-200 focus:outline-none focus:ring-0 hover:bg-gray-100 hover:text-ccColorTeal ${snippetSettings.emailEffectType === 'gameScreenshot' ? 'bg-gray-200' : 'bg-white'}`}
          onClick={()=>handleChangeSnippetSettings('emailEffectType', 'gameScreenshot')}>
        <div>
          Game Screenshot
        </div>
        <div className='text-sm mt-2 font-normal'>Use a screenshot of the memory game as the image.</div>
      </div>
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${snippetSettings.emailEffectType === 'gameAnimation' ? 'bg-gray-200' : 'bg-white'}`}
          onClick={()=>handleChangeSnippetSettings('emailEffectType', 'gameAnimation')}>
        <div>
          Game Screenshot with animation
        </div>
        <div className='text-sm mt-2 font-normal'>Create an animated gif of the memory game showing a few cards flipping.</div>
      </div>
    </div>

    {snippetSettings.emailEffectType === 'static' &&
        <div className='mt-2 flex flex-row gap-x-4 items-center'>
            <FileSelector noDeleteButton
            text="Upload image"
            onChange={handleStaticImageChange}
            />
            <div>
                {snippetSettings.emailEffectStaticImg === '' && <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex flex-col justify-center items-center'>
                    <Iconify icon="carbon:no-image" width={200} />
                    <div className='font-poppins font-semibold'>No image uploaded</div>
                </div>

                }
                {snippetSettings.emailEffectStaticImg !== '' &&
                <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex justify-center'>
                    <div className='relative h-full' >

                        <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${snippetSettings.emailEffectStaticImg}`} />
                        {/*<img className='max-w-none' src={`data:image;base64,${snippetSettings.teaserImgB64}`} />*/}


                    </div>
                </div>
                }
                {/*getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index) && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index).length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1 mb-8'>
                    <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />

                    {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index)}
                    </div>
                */}

            </div>
        </div>
    }
    <div style={{display: snippetSettings.emailEffectType === 'static' ? 'none' : 'block'}}>
      <div className='mt-2 text-lg font-semibold'>Image Preview</div>
      <div className='flex flex-row gap-x-2'>
        <div id='game-wrapper' style={{width: props.snippetInfo.snippetSettings.emailEffectImgSize.width, height: props.snippetInfo.snippetSettings.emailEffectImgSize.height}} className='resize relative overflow-auto ring-2 ring-gray-600'>
          <div id='game' ref={canvasRef} className='w-full h-full'></div>
          {snippetSettings.emailEffectType === 'gameScreenshot' && <>
          </>
          }
          
        </div>
        <div className='flex flex-col gap-y-2'>
          <div>Image size: <span className='border rounded px-2 py-1 bg-slate-50'>{canvasWidth} x {canvasHeight}</span>px</div>
          <div className='w-56'>
            <InputNumber displayName='Num cards to use'
                value={snippetSettings.numCardsInEmailEffectImg}
                max={40}
                onChange={(val) => handleChangeSnippetSettings('numCardsInEmailEffectImg', val)}
            />
          </div>
          <div className='mt-2 flex flex-col gap-y-0'>
              <FileSelector noDeleteButton
              text="Use a custom background image"
              onChange={handleStaticCustomBackgroundImageChange}
              />
              <div>
                  {snippetSettings.emailEffectCustomBackground === '' && <div className='bg-slate-200 rounded p-4 mt-1 w-[400px] h-[300px] flex flex-col justify-center items-center'>
                      <Iconify icon="carbon:no-image" width={200} />
                      <div className='font-poppins font-semibold'>No image uploaded</div>
                  </div>

                  }
                  {snippetSettings.emailEffectCustomBackground !== '' &&
                  <div className='bg-slate-200 rounded p-4 mt-1 w-[400px] h-[300px] flex justify-center'>
                      <div className='relative h-full' >

                          <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${snippetSettings.emailEffectCustomBackground}`} />
                          {/*<img className='max-w-none' src={`data:image;base64,${snippetSettings.teaserImgB64}`} />*/}

                          <div className='absolute -top-6 -right-[60px] '>
                            <IconButton sx={{width: '48px', height: '48px'}}
                              onClick={() => handleChangeSnippetSettings('emailEffectCustomBackground', '')}
                            ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>

                          </div>
                      </div>
                  </div>
                  }
                  {/*getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index) && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index).length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1 mb-8'>
                      <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />

                      {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index)}
                      </div>
                  */}

              </div>
          </div>

        </div>
      </div>
    </div>

        <Dialog
        maxWidth="lg"
        open={openResizeDialog}
       onClose={handleCloseResizeDialog}
      >

        <div className='w-[600px] h-[230px] p-2 flex flex-col gap-y-2 text-ccColorDarkTeal font-poppins'>
          <div className='text-lg font-semibold'>Would you like to resize your canvas?</div>
          <div>The size of the uploaded image ({openResizeDialogData.width}x{openResizeDialogData.height}px) is different than the current canvas size ({canvasWidth}x{canvasHeight}px)</div>
          <div>Would you like to resize your canvas to make it the same as the uploaded image?</div>
          <div className='mt-4 flex flex-row justify-end gap-x-2'>
            <CcActionButton onClick={() => handleCloseResizeDialog(true)}>Yes</CcActionButton>
            <CcActionButton onClick={() => handleCloseResizeDialog(false)}>No</CcActionButton>
          </div>
        </div>
      </Dialog>

    </div>

})

const AssetsTagViewer = (props) => {
  //used by MemoryCardsAssetsManager to show tags
  const [tags, setTags] = useState([])
  const [selectedTags, setSelectedTags] = useState([])
  const [openTagList, setOpenTagList] = useState(false);

  useEffect(() => {
    getTags()
  }, [])
  useEffect(() => {
    //we want to take only the card images coming from tags
    const imgsFromTags = props.snippetInfo.snippetSettings.cardImages.filter(c => (c.tagId !== undefined && c.tagId > 0))
    setSelectedTags(imgsFromTags)
  }, [props.snippetInfo])

  const getTags = async () => {
    
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/productTypes/1,9`;
      const response = await axios.get(url);

      setTags(response.data);


    } catch (error) {
      console.log(error);
    }
    
  }
  const getParams = async (tagId) => {
    
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/defaultValues/${tagId}`;
      const response = await axios.get(url);

      return response.data;


    } catch (error) {
      console.log(error);
    }
    
  }

  const handleCloseTagList = () => {
    setOpenTagList(false)
  }
  const RenderTag = ({tag}) => {
    return <div className='w-full'>
      <div className='flex flex-row items-center gap-x-2'>
        <Iconify icon={tag.snippetTypeId === 1 ? 'carbon:ibm-cloud-pak-business-automation' : 'bi:images'} width={38} />
        <div className='text-lg font-semibold'>{tag.snippetName}</div> 
      </div>
      <div className='ml-11 text-gray-600 text-sm italic'>{tag.snippetDesc}</div>
      <div className='mt-1 ml-4 flex flex-row items-center gap-x-2'>
        <Iconify icon={lionIcons.Icon_Calendar} width={16} />
        <div className='text-sm'>{new Date(Date.parse(tag.created)).toLocaleDateString()}</div> 
      </div>
    </div>
  }
const handleTagClick = async (tag) => {
  const newCardImage = {tagId: tag.snippetId, snippetTypeId: tag.snippetTypeId, srcPreview: extractImageSrc(tag.htmlCode),
                      srcWebPage: extractImageSrc(tag.htmlCode)
  }

  let newTags = [...selectedTags, newCardImage]
  handleCloseTagList()

  //IF GENERATOR
  //1. we temp add the newCard in the state so that we can show a loader
  //2. until we fetch the default preview url from the server
  //3. at this point we can bubble up
  // OTHERWISE we bubble up immediately
  if (tag.snippetTypeId === 1) {
    newTags = [...selectedTags, {...newCardImage, showLoader: true}]
    setSelectedTags(newTags)
    const paramsValues = await getParams(tag.snippetId)
    if (paramsValues.parameters) {
      const url = new URL(newCardImage.srcPreview);
      const urlWebPage = new URL(newCardImage.srcWebPage);
      const params = new URLSearchParams(url.search);
      const paramsWebPage = new URLSearchParams(urlWebPage.search);
      for (const p of paramsValues.parameters) {
        if (params.has(p.paramName)) {
          params.set(p.paramName, p.defaultValue)
          paramsWebPage.set(p.paramName, `{${p.defaultValue}}`)
        }
      }
      url.search = params.toString()
      urlWebPage.search = paramsWebPage.toString()
      newTags = [...selectedTags, {...newCardImage, showLoader: false, 
                                      srcPreview: url.toString(),
                                      srcWebPage: urlWebPage.toString(),
                                    numImages: 1}]
    }
  }

  
  if (props.onChange) {
    //when we bubble up we need to pass all the cardImages, both coming form a tag and not
    const imgsNotFromTags = props.snippetInfo.snippetSettings.cardImages.filter(c => (c.tagId === undefined))

    props.onChange([...newTags, ...imgsNotFromTags])
  }
  
}
function extractImageSrc(htmlString) {
  const match = htmlString.match(/<img[^>]*\s+src=["']([^"']+)["']/i);
  return match ? match[1] : null;
}
const getTagNameFromId = (tagId) => {
  try {
    const match = tags.find(t => t.snippetId === tagId)
    return match.snippetName
  }
  catch(e) {return ''}
}
const handleRemoveTag = (tagId) => {
  const newTags = [...selectedTags]
  const index = newTags.findIndex(t => t.tagId === tagId)
  newTags.splice(index, 1)
  if (props.onChange) {
    //when we bubble up we need to pass all the cardImages, both coming form a tag and not
    const imgsNotFromTags = props.snippetInfo.snippetSettings.cardImages.filter(c => (c.tagId === undefined))

    props.onChange([...newTags, ...imgsNotFromTags])
  }

}
const handleChangeTagNumImages = (tagId, numImages) => {
  //for CA tag only. It changes the num images to use with that tag
  const newTags = [...selectedTags]
  const index = newTags.findIndex(t => t.tagId === tagId)
  newTags[index].numImages = numImages
  if (props.onChange) {
    //when we bubble up we need to pass all the cardImages, both coming form a tag and not
    const imgsNotFromTags = props.snippetInfo.snippetSettings.cardImages.filter(c => (c.tagId === undefined))

    props.onChange([...newTags, ...imgsNotFromTags])
  }

}

  return <div>
    <button className='w-64 mb-2 border rounded px-2 py-1 hover:bg-slate-200'
    onClick={() => setOpenTagList(true)}
    >Add a tag</button>
    {selectedTags.map(t => <div>
      <div className='flex flex-row items-center gap-x-2'>
        <Iconify icon={t.snippetTypeId === 1 ? 'carbon:ibm-cloud-pak-business-automation' : 'bi:images'} width={38} />
        <div className='text-lg font-semibold'>{getTagNameFromId(t.tagId)}</div> 
        <div className='flex grow'></div>
        <IconButton sx={{m:1}} 
          onClick={() => handleRemoveTag(t.tagId)}
          ><Iconify icon={lionIcons.Icon_Actions_Cancel} width={32} /></IconButton>
      </div>
      <div className='text-xs'>{t.srcPreview}</div>
      {t.showLoader ? <div className='w-fit flex flex-col items-center'>
                          <CcLoader />
                          <div className='text-xs font-poppins'>Finding preview</div>
                      </div>
                
      :
        <>
          {t.snippetTypeId === 1 ?
          <div>
            <div className='flex flex-row gap-x-2'>
              {[...Array(t.numImages)].map((_, index) => <div className='bg-slate-200 rounded p-2 w-fit'>
                                                  <img style={{height: 'auto', width: '200px', maxHeight: '100%'}} src={t.srcPreview.replace("element=1",`element=${index+1}`)} />
                                                  </div>)
              }
            </div>

            <div className='w-56'>
              <InputNumber displayName='How many images with this tag'
                  value={t.numImages}
                  max={4}
                  onChange={(val) => handleChangeTagNumImages(t.tagId, val)}
              />
            </div>
          </div>
          :
            <div className='bg-slate-200 rounded p-2 w-fit'><img style={{height: 'auto', width: '200px', maxHeight: '100%'}} src={t.srcPreview} /></div>
          }
        </>
      }

    </div>)}

        <Dialog
        maxWidth="lg"
        open={openTagList}
       onClose={handleCloseTagList}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className='flex justify-end'>
          <IconButton sx={{m:1}} 
          onClick={handleCloseTagList}
          ><Iconify icon={lionIcons.Icon_Actions_Cancel} width={40} /></IconButton>
        </div>

        <div className='w-[600px] h-[400px] overflow-auto px-2 flex flex-col gap-y-2 text-ccColorDarkTeal font-poppins'>
          {tags.filter(t => !selectedTags.some(st => st.tagId === t.snippetId)).map(t => <div className='w-full border rounded px-2 py-1 cursor-pointer hover:bg-slate-200'
                               onClick={() => handleTagClick(t)}>
                        <RenderTag tag={t} />
                        </div>)
          }  
        </div>
      </Dialog>
  </div>
}
export function MemoryCardsAssetsManager(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  */

  const {settings, setSettings} = useContext(SettingsContext);

  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [snippetSettings, setSnippetSettings] = useState({ cardImages: [{imgB64: '', tagId: undefined}]})

  const [numImages, setNumImages] = useState(0)

  const [generatingTeaser, setGeneratingTeaser] = useState(false)

  useEffect(() => {
    if (props.snippetInfo) {
      //console.log(props.snippetInfo)
      setSnippetName(props.snippetInfo.snippetName)
      setSnippetDesc(props.snippetInfo.snippetDesc)
      setSnippetSettings(props.snippetInfo.snippetSettings)
      setNumImages(countImages(props.snippetInfo.snippetSettings.cardImages))
    }
    else {
      
    }
  }, [props.templateId, props.snippetInfo, settings])


  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 22,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};

    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;
    result.snippetSettings = snippetSettings;
    result.webPageSettings = props.snippetInfo.webPageSettings;

    if (updatePropName) {
      result[updatePropName] = updatePropValue;
    }
      //console.log(result)
      return result;
  }

  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }

  const handleImageChange = (index, dataURL) => {

    const newCardImages = [...snippetSettings.cardImages]
    newCardImages.splice(index, 1, {imgB64: dataURL})

    const newSnippetSettings = {...snippetSettings, cardImages: newCardImages }
    setSnippetSettings(newSnippetSettings)
    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))

  }


const handleAddImage = () => {
  const newCardImages = [...snippetSettings.cardImages]
  
  newCardImages.push({imgB64: ''})

  const newSnippetSettings = {...snippetSettings, cardImages: newCardImages }
  setSnippetSettings(newSnippetSettings)
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))
}

const handleRemoveImage = (index) => {
  //NOTE: the index param refers to the index of an array of ONLY images not coming from a tag
  //here we have all the images mixed together so we need to first filter

  const newCardImages = [...snippetSettings.cardImages]
  let filteredIndex = -1
  let finalIndex = -1
  for (let i=0; i<newCardImages.length; i+=1) {
    if (newCardImages[i].tagId && newCardImages[i].tagId > 0) continue
    filteredIndex +=1
    if (filteredIndex === index) {
      finalIndex = i
      break
    }
  }
  
  newCardImages.splice(finalIndex, 1)

  const newSnippetSettings = {...snippetSettings, cardImages: newCardImages }
  setSnippetSettings(newSnippetSettings)
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))

}

  const handleTagImageChange = (newCardImages) => {

    console.log(newCardImages)

    const newSnippetSettings = {...snippetSettings, cardImages: newCardImages }
    setSnippetSettings(newSnippetSettings)
    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))

  }


  return <div className='text-ccColorDarkTeal p-2 flex flex-col'>
    <div className='flex flex-row gap-x-4'>
      <div className="w-96">
        <InputText
                displayName="Name"
                value={snippetName}
                onChange={(val) => {handleSnippetNameChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'snippetName')}
        />
      </div>

      <div className="w-96">
        <InputText
                  displayName="Description"
                  value={snippetDesc}
                  onChange={(val) => {handleSnippetDescChange(val);}}
                  error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
        />
      </div>
    </div>
    <div className='mt-4 flex flex-row gap-x-4 items-center'>
        <div className='text-lg font-semibold'>Define images below</div>
        <div className='border bg-slate-50 rounded px-2 py-1 font-semibold'>Current game status: {numImages} images, {numImages * 2} cards</div>
    </div>
    <div className='mt-1 grid grid-cols-2'>
        <div>
            <div>Add your own images</div>
            {snippetSettings.cardImages.filter(c => c.tagId === undefined).map((c, index) => <>
                <div className='flex flex-row gap-x-4 items-center'>
                    <FileSelector noDeleteButton
                    text="Upload image"
                    onChange={(dataUrl) => handleImageChange(index, dataUrl)}
                    />
                    <div>
                        {c.imgB64 === '' && <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex flex-col justify-center items-center'>
                            <Iconify icon="carbon:no-image" width={200} />
                            <div className='font-poppins font-semibold'>No image uploaded</div>
                        </div>

                        }
                        {generatingTeaser &&
                        <div className='mt-4 flex justify-center'><CcLoader size={96} /></div>
                        }
                        {c.imgB64 !== '' && !generatingTeaser &&
                        <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex justify-center'>
                            <div className='relative h-full' >

                                <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${c.imgB64}`} />
                                {/*<img className='max-w-none' src={`data:image;base64,${snippetSettings.teaserImgB64}`} />*/}


                            </div>
                        </div>
                        }
                        {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index) && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index).length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1 mb-8'>
                            <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />

                            {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index)}
                            </div>
                        }

                    </div>
                    <div>
                        <IconButton 
                            onClick={() => handleRemoveImage(index)}
                        ><Iconify icon={lionIcons.Icon_Actions_Cancel} width={36} /></IconButton>
                    </div>

                </div>
            </>)
            }

        </div>
        <div>
            <div>Use an element tag as an image</div>
            <AssetsTagViewer snippetInfo={props.snippetInfo}
              onChange={handleTagImageChange}
             />
        </div>

    </div>



      <CcActionButton className="w-fit mt-4"
        onClick={handleAddImage}
      >Add another image</CcActionButton>
    </div>

}

export const MemoryCardsWebPageManager = (props) => {

  const [templates, setTemplates] = useState([])
  const [selectedTemplateId, setSelectedTemplateId] = useState(0)
  const [templatePropValuesCollection, setTemplatePropValuesCollection] = useState([]) //[{propName: '', propValue: ''}]
  const [fonts, setFonts] = useState([])
  const [coverType, setCoverType] = useState('solidColor') //can be: 'solidColor', 'useEmailCover', 'image' 
  const [coverSolidColor, setCoverSolidColor] = useState('#b3b3b3')
  //const [coverAddEffect, setCoverAddEffect] = useState(true)
  const [timeZones, setTimeZones] = useState(undefined);
  const [href, setHref] = useState('')



  useEffect(() => {
    if (props.snippetInfo) {
        //console.log(props.snippetInfo)

      if (props.snippetInfo.webPageSettings) {
        //console.log(props.snippetInfo.webPageSettings)
        setSelectedTemplateId(props.snippetInfo.webPageSettings.selectedWebPageId)
        setTemplatePropValuesCollection(props.snippetInfo.webPageSettings.templatePropValuesCollection)
        setCoverType(props.snippetInfo.webPageSettings.coverType)
        setCoverSolidColor(props.snippetInfo.webPageSettings.coverSolidColor)
        setHref(props.snippetInfo.webPageSettings.href)
        //setCoverAddEffect(props.snippetInfo.webPageSettings.coverAddEffect)
      }
      else {

      }
    }
    if (templates.length === 0) {
      let initialTemplateId = 4
      if (props.snippetInfo && props.snippetInfo.webPageSettings) initialTemplateId = props.snippetInfo.webPageSettings.selectedWebPageId
      getTemplates(initialTemplateId);
    }
    if (fonts.length === 0) getFonts();
  
  }, [props.snippetInfo])

  useEffect(() => {
    getTimezones()
  }, [])

  const getTemplates = async (initialTemplateId) => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/WebPages/Templates/22`;

      const response = await axios.get(url);
      setTemplates(response.data);
      setSelectedTemplateId(initialTemplateId)
      if (props.snippetInfo.webPageSettings.templatePropValuesCollection.length === 0) initTemplatePropValuesCollection(initialTemplateId, response.data)
      
    } catch (error) {
      //console.log(error);
    }

  }
  const getFonts = async () => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/WebPages/GoogleFontsList`;

      const response = await axios.get(url);
      setFonts(response.data);
      
    } catch (error) {
      //console.log(error);
    }

  }
  const doOnChange = (templateId, values) => {
    if (props.onChange) {
      const result = {selectedWebPageId: templateId, templatePropValuesCollection: values, coverType: coverType, coverSolidColor: coverSolidColor,
                     coverAddEffect: props.snippetInfo.webPageSettings.coverAddEffect, confettiAddEffect: props.snippetInfo.webPageSettings.confettiAddEffect,
                     confettiColors: props.snippetInfo.webPageSettings.confettiColors,
                     href: props.snippetInfo.webPageSettings.href,
                     expiryDate: props.snippetInfo.webPageSettings.expiryDate, expiryTimezoneId: props.snippetInfo.webPageSettings.expiryTimezoneId }
      props.onChange(result)
    }
  }
  const doOnChangeWithNewValue = (propName, propValue) => {
    if (props.onChange) {
      const result = {selectedWebPageId: selectedTemplateId, templatePropValuesCollection: templatePropValuesCollection, coverType: coverType, coverSolidColor: coverSolidColor,
                     coverAddEffect: props.snippetInfo.webPageSettings.coverAddEffect, confettiAddEffect: props.snippetInfo.webPageSettings.confettiAddEffect,
                     confettiColors: props.snippetInfo.webPageSettings.confettiColors,
                     href: props.snippetInfo.webPageSettings.href,
                      expiryDate: props.snippetInfo.webPageSettings.expiryDate, expiryTimezoneId: props.snippetInfo.webPageSettings.expiryTimezoneId}
      result[propName] = propValue;
      props.onChange(result)
    }
  }


  const initTemplatePropValuesCollection = (templateId, _templates) => {
    let activeTemplate = undefined;
    if (_templates) activeTemplate = _templates.find(t => t.webPageTemplateId === templateId)
    else activeTemplate = templates.find(t => t.webPageTemplateId === templateId)

    if (_templates !== undefined) {
      const result = []
      activeTemplate.placeHolders.forEach(p => {result.push({propName: p.codeName, propValue: p.defaultValue})})
      result.push({propName: 'brushStrokeWidth',  propValue: '35'})
      result.push({propName: 'timeoutToReveal',  propValue: '1600'})
      doOnChange(templateId, result)
      return result;
    }
    return templatePropValuesCollection;
  }

  const getTemplatePropValue = (propName) => {
    //retrieve the prop value (give its name) from the templatePropValuesCollection
    const matchedProp = templatePropValuesCollection.find(pv => pv.propName === propName);
    if (matchedProp && (matchedProp.propValue !== '' || !props.prePopulateMsg)) return matchedProp.propValue;
    else {
      //we try to get the default value if available
      const activeTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId)
      if (activeTemplate === undefined) return ''
      const currentPlaceholder = activeTemplate.placeHolders.find(p => p.codeName === propName)
      if (currentPlaceholder === undefined) return ''
      return currentPlaceholder.defaultValue ?? ''
    }
    
  }
  const setTemplatePropValue = (propName, propValue) => {
    //retrieve the prop value (give its name) from the templatePropValuesCollection
    const matchedIndex = templatePropValuesCollection.findIndex(pv => pv.propName === propName);
    const newValues = [...templatePropValuesCollection];

    //newValues.splice(matchedIndex, 1, {propName: propName, propValue: propValue})
    //setTemplatePropValuesCollection(newValues)
    //console.log(newValues)
    //if (propValue === '') propValue = 'cc-null'
    
    if (matchedIndex === -1) {
      newValues.push({propName: propName, propValue: propValue})
      setTemplatePropValuesCollection(newValues)
    }
    else {
      newValues.splice(matchedIndex, 1, {propName: propName, propValue: propValue})
      setTemplatePropValuesCollection(newValues)
    }
    
    doOnChange(selectedTemplateId, newValues)
  }

  const handleTimezoneChange = (timezone) => {
    doOnChangeWithNewValue('expiryTimezoneId', timezone.id)

  }
 
  const handleConfettiColorsChange = (newColors) => {
    doOnChangeWithNewValue('confettiColors', newColors)
  }

  const renderBackgroundSettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pBgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-body-bg-color}')
    const pBgImg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-body-bg-image}')
    const pMainContentBgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-main-content-bg-color}')
    const pLogoImg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-logo-image}')
    
    return <div className='bg-slate-100 border rounded p-2'>
      <div className='text-lg font-poppins font-bold mb-2'>Background Configuration</div>
      <div className='flex flex-row items-center'>
        <div className='w-[310px]'>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              Background Colour
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pBgColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pBgColor.codeName, val);}}
            />

        </div>

        <div>
            <div className='flex flex-row items-center gap-x-1'>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                Background image
                </div>
              <InfoToolTip 
                          placement='right'
                          headLine='Background image'
                          message="We recommend uploading an image with a width of 1920px. This is generally accepted standard for optimal background image size. The height can be variable but for desktop displays 1920 x 1080 pixels is an optimal background image size."
                        />

            </div>
              <div className='flex flex-row gap-x-2 items-center'>
                <FileSelector noDeleteButton
                  text="Upload"
                  onChange={(dataURL) => setTemplatePropValue(pBgImg.codeName, dataURL)}
                />
                {getTemplatePropValue(pBgImg.codeName).length === 0 && 
                  <div>Not used</div>
                }
                {getTemplatePropValue(pBgImg.codeName).length > 0 && <div className='flex flex-row gap-x-1'>
                            <div className='bg-slate-200 rounded p-4 mt-2 max-w-[380px] max-h-[230px] flex justify-center'>
                              <div className='relative flex justify-center' >
                                  <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${getTemplatePropValue(pBgImg.codeName)}`} />                              
                              </div>
                            </div>
                            <IconButton sx={{width: '48px', height: '48px'}}
                              onClick={() => setTemplatePropValue(pBgImg.codeName, '')}
                            ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>
                        </div>                          
                }
              </div>
        </div>
  
      </div>

      <div className='flex flex-row items-center mt-4'>
        <div className='w-[310px]'>
          <div className='flex flex-row items-center gap-x-1'>
            <div  className="text-sm font-poppins font-medium leading-6 text-gray-900">
              Main Content Tile background colour
            </div>
            <InfoToolTip 
                  placement='right'
                  headLine='Main Content Tile background colour'
                  message="This is the area that your Scratch off and content will be displayed over. "
                />
          </div>
            <LionColorPicker
              color={getTemplatePropValue(pMainContentBgColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pMainContentBgColor.codeName, val);}}
            />

        </div>

        <div>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              Logo image
              </div>
              <div className='flex flex-row gap-x-2 items-center'>
                <FileSelector noDeleteButton
                  text="Upload"
                  onChange={(dataURL) => setTemplatePropValue(pLogoImg.codeName, dataURL)}
                />
                {getTemplatePropValue(pLogoImg.codeName).length === 0 && 
                  <div>Not used</div>
                }
                {getTemplatePropValue(pLogoImg.codeName).length > 0 && <div className='flex flex-row gap-x-1'>
                            <div className='bg-slate-200 rounded p-4 mt-2 max-w-[380px] max-h-[230px] flex justify-center'>
                              <div className='relative flex justify-center' >
                                  <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${getTemplatePropValue(pLogoImg.codeName)}`} />                              
                              </div>
                            </div>
                            <IconButton sx={{width: '48px', height: '48px'}}
                              onClick={() => setTemplatePropValue(pLogoImg.codeName, '')}
                            ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>
                        </div>                          
                }
              </div>
        </div>

      </div>
      </div>
  }
  const renderCardsAreaSettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    //const pBgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-body-bg-color}')
    const pBgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-card-bg-color}')
    const pBgImg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-card-bg-image}')
    const pAreaBgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-game-bg-color}')

    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Cards Area Configuration</div>

      <div className='flex flex-col items-start'>
        <div className='w-[310px]'>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              Game Area Background Colour
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pAreaBgColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pAreaBgColor.codeName, val);}}
            />

        </div>
        <div className='flex flex-row items-center'>
          <div className='w-[310px]'>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                Cards Background Colour
              </div>
              <LionColorPicker
                color={getTemplatePropValue(pBgColor.codeName)}
                onChange={(val) => {setTemplatePropValue(pBgColor.codeName, val);}}
              />

          </div>

          <div>
              <div className='flex flex-row items-center gap-x-1'>
                <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                  Cards Background image
                  </div>
                <InfoToolTip 
                            placement='right'
                            headLine='Background image'
                            message="We recommend uploading an image with a width of 1920px. This is generally accepted standard for optimal background image size. The height can be variable but for desktop displays 1920 x 1080 pixels is an optimal background image size."
                          />

              </div>
                <div className='flex flex-row gap-x-2 items-center'>
                  <FileSelector noDeleteButton
                    text="Upload"
                    onChange={(dataURL) => setTemplatePropValue(pBgImg.codeName, dataURL)}
                  />
                  {getTemplatePropValue(pBgImg.codeName).length === 0 && 
                    <div>Not used</div>
                  }
                  {getTemplatePropValue(pBgImg.codeName).length > 0 && <div className='flex flex-row gap-x-1'>
                              <div className='bg-slate-200 rounded p-4 mt-2 max-w-[380px] max-h-[230px] flex justify-center'>
                                <div className='relative flex justify-center' >
                                    <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${getTemplatePropValue(pBgImg.codeName)}`} />                              
                                </div>
                              </div>
                              <IconButton sx={{width: '48px', height: '48px'}}
                                onClick={() => setTemplatePropValue(pBgImg.codeName, '')}
                              ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>
                          </div>                          
                  }
                </div>
          </div>

        </div>


        <div className='mt-2'>
          <CcCheckbox
              displayName={<div className='flex flex-row items-center gap-x-1'><div>Add Confetti Effect</div>
                          <InfoToolTip 
                                  placement='right'
                                  headLine='Add Confetti Effect'
                                  message="Upon completing the scratch, confetti will be displayed."
                              />
                          </div>}
            checked={(props.snippetInfo.webPageSettings && props.snippetInfo.webPageSettings.confettiAddEffect) ? props.snippetInfo.webPageSettings.confettiAddEffect : false}
          onChange={(e) => {doOnChangeWithNewValue('confettiAddEffect', e.target.checked);}}
          />
          {props.snippetInfo.webPageSettings && props.snippetInfo.webPageSettings.confettiAddEffect && <div>
            <LionMultiColorPicker colors={props.snippetInfo.webPageSettings.confettiColors}
              onChange={handleConfettiColorsChange}
            />
          </div>          
          }
        </div>


      </div>


      </div>
  }
  const renderTextContentSettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pMainContentTitle = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-Main-Content-Title-MemoryCards}')
    const pMainContentTitleFont = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-Main-Content-Title-Font}')
    const pMainContentTitleSize = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-Main-Content-Title-Size}')
    const pMainContentTitleColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-Main-Content-Title-Color}')

    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Text Content Configuration</div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputText
              displayName={pMainContentTitle.prettyName}
              value={getTemplatePropValue(pMainContentTitle.codeName)}
              onChange={(val) => {setTemplatePropValue(pMainContentTitle.codeName, val);}}
            />

          </div>

          <div>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                {pMainContentTitleFont.prettyName}
              </div>
              <GoogleFontsSelector
                    fonts={fonts}
                    selected={getTemplatePropValue(pMainContentTitleFont.codeName)}
                    onChange={(val) => {setTemplatePropValue(pMainContentTitleFont.codeName, val);}}
              />
          </div>

        </div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputNumber
                displayName={pMainContentTitleSize.prettyName}
                value={getTemplatePropValue(pMainContentTitleSize.codeName)}
                onChange={(val) => {setTemplatePropValue(pMainContentTitleSize.codeName, val.toString());}}
                  />
          </div>

          <div>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              {pMainContentTitleColor.prettyName}
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pMainContentTitleColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pMainContentTitleColor.codeName, val);}}
            />

          </div>

        </div>
      </div>
  }
  const renderBodyContentSettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pScratchToRevealMsg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-memory-cards-msg}')
    const pScratchToRevealMsgFont = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-scratch-to-reveal-msg-font}')
    const pScratchToRevealMsgSize = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-scratch-to-reveal-msg-size}')
    const pScratchToRevealMsgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-scratch-to-reveal-msg-color}')

    const pPostScratchToRevealMsg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-game-msg}')
    const pPostScratchToRevealMsgFont = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-game-msg-font}')
    const pPostScratchToRevealMsgSize = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-game-msg-size}')
    const pPostScratchToRevealMsgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-game-msg-color}')
    
    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Body Content Configuration</div>

      <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputText
                displayName={<div className='flex flex-row items-center gap-x-1'><div>{pScratchToRevealMsg.prettyName}</div>
                  <InfoToolTip 
                      placement='right'
                      headLine={pScratchToRevealMsg.prettyName}
                      message="This is the supporting content you wish to display before the scratch off is revealed. This message will be swapped once the content has been revealed."
                  />
              </div>}
              value={getTemplatePropValue(pScratchToRevealMsg.codeName)}
              onChange={(val) => {setTemplatePropValue(pScratchToRevealMsg.codeName, val);}}
            />

          </div>


          <div>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                {pScratchToRevealMsgFont.prettyName}
              </div>
              <GoogleFontsSelector
                    fonts={fonts}
                    selected={getTemplatePropValue(pScratchToRevealMsgFont.codeName)}
                    onChange={(val) => {setTemplatePropValue(pScratchToRevealMsgFont.codeName, val);}}
              />
          </div>

        </div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputNumber
                displayName={pScratchToRevealMsgSize.prettyName}
                value={getTemplatePropValue(pScratchToRevealMsgSize.codeName)}
                onChange={(val) => {setTemplatePropValue(pScratchToRevealMsgSize.codeName, val.toString());}}
                  />
          </div>

          <div>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              {pScratchToRevealMsgColor.prettyName}
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pScratchToRevealMsgColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pScratchToRevealMsgColor.codeName, val);}}
            />

          </div>

        </div>

        <div className='flex flex-row items-center gap-x-6 mt-4'>
          <div className='w-[260px]'>
            <InputText
                displayName={<div className='flex flex-row items-center gap-x-1'><div>{pPostScratchToRevealMsg.prettyName}</div>
                  <InfoToolTip 
                      placement='right'
                      headLine={pPostScratchToRevealMsg.prettyName}
                      message="This is the content you wish to display once the scratch off has been successfully completed."
                  />
              </div>}
              value={getTemplatePropValue(pPostScratchToRevealMsg.codeName)}
              onChange={(val) => {setTemplatePropValue(pPostScratchToRevealMsg.codeName, val);}}
            />

          </div>


          <div>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                {pPostScratchToRevealMsgFont.prettyName}
              </div>
              <GoogleFontsSelector
                    fonts={fonts}
                    selected={getTemplatePropValue(pPostScratchToRevealMsgFont.codeName)}
                    onChange={(val) => {setTemplatePropValue(pPostScratchToRevealMsgFont.codeName, val);}}
              />
          </div>

        </div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputNumber
                displayName={pPostScratchToRevealMsgSize.prettyName}
                value={getTemplatePropValue(pPostScratchToRevealMsgSize.codeName)}
                onChange={(val) => {setTemplatePropValue(pPostScratchToRevealMsgSize.codeName, val.toString());}}
                  />
          </div>

          <div>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              {pPostScratchToRevealMsgColor.prettyName}
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pPostScratchToRevealMsgColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pPostScratchToRevealMsgColor.codeName, val);}}
            />

          </div>

        </div>

      </div>
  }
  const renderCallToActionSettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pPostScratchBtnTitle = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-game-button-title}')
    const pPostScratchBtnTitleFont = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-game-button-title-font}')
    const pPostScratchBtnTitleSize = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-game-button-title-size}')
    const pPostScratchBtnTitleColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-game-button-title-textcolor}')
    const pPostScratchBtnTitleBgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-game-button-title-bgcolor}')
    const pPostScratchBtnCorners = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-cta-border-radius}')
    
    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Call To action Configuration</div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputText
              displayName={pPostScratchBtnTitle.prettyName}
              value={getTemplatePropValue(pPostScratchBtnTitle.codeName)}
              onChange={(val) => {setTemplatePropValue(pPostScratchBtnTitle.codeName, val);}}
            />

          </div>

          <div>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                {pPostScratchBtnTitleFont.prettyName}
              </div>
              <GoogleFontsSelector
                    fonts={fonts}
                    selected={getTemplatePropValue(pPostScratchBtnTitleFont.codeName)}
                    onChange={(val) => {setTemplatePropValue(pPostScratchBtnTitleFont.codeName, val);}}
              />
          </div>

        </div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputNumber
                displayName={pPostScratchBtnTitleSize.prettyName}
                value={getTemplatePropValue(pPostScratchBtnTitleSize.codeName)}
                onChange={(val) => {setTemplatePropValue(pPostScratchBtnTitleSize.codeName, val.toString());}}
                  />
          </div>

          <div>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              {pPostScratchBtnTitleColor.prettyName}
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pPostScratchBtnTitleColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pPostScratchBtnTitleColor.codeName, val);}}
            />

          </div>

          <div>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              {pPostScratchBtnTitleBgColor.prettyName}
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pPostScratchBtnTitleBgColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pPostScratchBtnTitleBgColor.codeName, val);}}
            />

          </div>

        </div>

        <div className='mt-3'>
          <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              Button corners
          </div>
          <div className='flex flex-row gap-x-4 cursor-pointer -mt-2'>
            <div className='flex flex-row items-center -ml-3' onClick={() => {setTemplatePropValue(pPostScratchBtnCorners.codeName, 'rounded')}}>
              <Radio
                checked={getTemplatePropValue(pPostScratchBtnCorners.codeName) === 'rounded'}
                onChange={() => setTemplatePropValue(pPostScratchBtnCorners.codeName, 'rounded')}
                name="radio-coverType"
                inputProps={{ 'aria-label': 'A' }}
                sx={{
                  '&.Mui-checked': {
                    color: ccColorTeal,
                  },
                }}
              />
              <div>Rounded corners</div>
            </div>
            <div className='flex flex-row items-center' onClick={() => {setTemplatePropValue(pPostScratchBtnCorners.codeName, 'square')}}>
              <Radio
                checked={getTemplatePropValue(pPostScratchBtnCorners.codeName) === 'square'}
                onChange={() => setTemplatePropValue(pPostScratchBtnCorners.codeName, 'square')}
                name="radio-coverType"
                inputProps={{ 'aria-label': 'A' }}
                sx={{
                  '&.Mui-checked': {
                    color: ccColorTeal,
                  },
                }}
              />
              <div>Square corners</div>
            </div>
          </div>
        </div>


        <div className="w-[450px] font-roboto mt-4">
            <div className='flex flex-row items-center gap-x-1'>
              <label htmlFor="Endpoint" className="block text-sm font-medium text-ccColorDarkTeal font-poppins">
                Button HREF
              </label>
              <InfoToolTip 
                  placement='right'
                  headLine='Button HREF'
                  message="Insert the URL that you wish to direct participants to. This link should include any discount population parameters and tracking that you wish to carry forward."
              />
            </div>

            <InputURL
              //displayName="Name"
              value={props.snippetInfo.webPageSettings.href}
              onChange={handleHrefChange}
              error={getErrorMessage(props.validationErrorsList, 'href')}
              />
          </div>
      

      </div>
  }
  const renderExpirySettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pExpiredMsg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-expired-msg}')
    const pExpiredBtnText = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-expired-button-title}')
    const pExpiredBtnHref = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-expired-href}')
    
    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Expiry Configuration</div>

        <div className='flex flex-row items-center gap-x-6'>
            <div className='w-[260px]'>
              <InputText
                displayName={pExpiredMsg.prettyName}
                value={getTemplatePropValue(pExpiredMsg.codeName)}
                onChange={(val) => {setTemplatePropValue(pExpiredMsg.codeName, val);}}
                error={getErrorMessageForArray(props.validationErrorsList, 'expirySettings', 'expired-msg')}
              />

            </div>

            <div className='flex flex-row items-center gap-x-4'>
          <div>
          <label htmlFor="timerDate" className="block text-sm font-medium leading-6 text-gray-900">
            Date
          </label>
          <div className="mt-1">
          <DateTimePicker
                value={dayjs(props.snippetInfo.webPageSettings.expiryDate)}
                ampm={false}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                onChange={handleTimerDateChange}
              />
          </div>
          </div>        
          <div>
            <label htmlFor="snippetDescription" className="block text-sm font-medium leading-6 text-gray-900">
              Time zone
            </label>
            <div className="mt-1">
              <LionCombo items={timeZones}
                onChange={handleTimezoneChange}
                selectedItemId={props.snippetInfo.webPageSettings.expiryTimezoneId}
                zIndex={100}
              />
            </div>
          </div>

            </div>

        </div>

        <div className='flex flex-row items-center gap-x-6'>
            <div className='w-[260px] mt-4'>
              <InputText
                displayName="Expired button text"
                value={getTemplatePropValue(pExpiredBtnText.codeName)}
                onChange={(val) => {setTemplatePropValue(pExpiredBtnText.codeName, val);}}
                error={getErrorMessageForArray(props.validationErrorsList, 'expirySettings', 'expired-button-title')}
              />

            </div>

            <div className="w-[450px] font-roboto mt-4">
            <div className='flex flex-row items-center gap-x-1'>
              <label htmlFor="Endpoint" className="block text-sm font-medium text-ccColorDarkTeal font-poppins">
                Expired button HREF
              </label>
              {/*
              <InfoToolTip 
                  placement='right'
                  headLine='Button HREF'
                  message="Insert the URL that you wish to direct participants to. This link should include any discount population parameters and tracking that you wish to carry forward."
              />
               */}
            </div>

            <InputURL
              //displayName="Name"
              value={getTemplatePropValue(pExpiredBtnHref.codeName)}
              onChange={(val) => {setTemplatePropValue(pExpiredBtnHref.codeName, val);}}
              error={getErrorMessageForArray(props.validationErrorsList, 'expirySettings', 'expired-href')}
              />
          </div>

        </div>

      </div>
  }
  const renderPageMetadataSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pWebpageTitle = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-webpage-title-memory-cards}')
    
    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Page Metadata Configuration</div>

        <div className='w-[260px]'>
            <InputText
              displayName="Title"
              value={getTemplatePropValue(pWebpageTitle.codeName)}
              onChange={(val) => {setTemplatePropValue(pWebpageTitle.codeName, val);}}
            />

        </div>


      </div>
  }


  const getTimezones = async () => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Settings/timezones`;
      const response = await axios.get(url);
      const data = response.data;

      const result = data.map(d => {return {id: d.zoneId, name: d.zoneName}});
      setTimeZones(result);

    } catch (error) {
      //console.log(error);
    }
  }
  const handleTimerDateChange = (newDate) => {
    //newDate.$d.setSeconds(0); //we don't allow to set seconds, for safety we always set them to 0
    //console.log(newDate)
    //console.log(newDate.toJSON())
    doOnChangeWithNewValue('expiryDate', newDate.toJSON())
  }

  const handleHrefChange = (href) => {
    doOnChangeWithNewValue('href', href)

  }

  return <div className='text-ccColorDarkTeal'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className='text-lg font-poppins font-bold hidden'>Select a layout</div>
      <div className='grid grid-cols-3 gap-4 h-[160px] overflow-auto hidden'>
        {templates.map(t => <div className={`h-fit p-1 col-span-1 rounded ${selectedTemplateId === t.webPageTemplateId ? 'bg-ccColorLightTeal' :''} hover:bg-ccColorDarkTeal`}> 
            <div className={`relative  p-1 h-32 cursor-pointer  bg-slate-200 rounded flex items-center justify-center `}
              onClick={() => {setSelectedTemplateId(t.webPageTemplateId); /*setTemplatePropValuesCollection(initTemplatePropValuesCollection(t.webPageTemplateId));*/}}
              >
                  <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={t.thumbnailB64} alt='' />    
            </div>
          </div>)
        }
      </div>
      {renderBackgroundSettingsSection()}
      {renderCardsAreaSettingsSection()}
      {renderTextContentSettingsSection()}
      {renderBodyContentSettingsSection()}
      {renderCallToActionSettingsSection()}
      {renderExpirySettingsSection()}
      {renderPageMetadataSection()}

{/* 
    <div className='bg-slate-100 border rounded p-2 mt-6'>
      <div className='text-lg font-poppins font-bold mb-2'>Configure</div>
      <div className='grid grid-cols-2 gap-x-4 gap-y-4'>
        {renderLayoutSettings()}
      </div>
    </div>
*/}

    </LocalizationProvider>
  </div>
}


const WebPagePreviewer = (props) => {
  /*
  props:

  onRequestPointerB64: we need to use this to request the pointer image if coverAddEffect = true
  */
  const [fetchingPreview, setFetchingPreview] = useState(false)
  const [previewHtml, setPreviewHtml] = useState('')


  const getWebPagePreview = () => {
    setOpenPreviewDialog(true)
    setFetchingPreview(true)
    getPreviewHtml()
  }

  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const handleClosePreviewDialog = () => {
    setOpenPreviewDialog(false)
  }

  const getPreviewHtml = async () => {
    setPreviewHtml('')
    //console.log(props.snippetInfo)
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/WebPages/PreviewMemoryCards`;
      const dataToPost = {snippetTypeId: 22, webPageTemplateId: props.snippetInfo.webPageSettings.selectedWebPageId,
                            href: props.snippetInfo.webPageSettings.href
                          ,propValuesCollection: props.snippetInfo.webPageSettings.templatePropValuesCollection
                          ,coverType: props.snippetInfo.webPageSettings.coverType, coverSolidColor: props.snippetInfo.webPageSettings.coverSolidColor 
                          ,coverB64: props.snippetInfo.snippetSettings.teaserImgB64
                          ,expiryDate: props.snippetInfo.webPageSettings.expiryDate, expiryTimezoneId: props.snippetInfo.webPageSettings.expiryTimezoneId
                          ,confettiAddEffect: props.snippetInfo.webPageSettings.confettiAddEffect, confettiColors: JSON.stringify(props.snippetInfo.webPageSettings.confettiColors)
                          ,cardImages: props.snippetInfo.snippetSettings.cardImages }

        
      const response = await axios.post(url, dataToPost);
      //setPreviewHtml(response.data)
      
      const blob = new Blob([response.data], { type: 'text/html' });

      // Generate a URL for the Blob
      const blobUrl = URL.createObjectURL(blob);

      // Open the Blob URL in a new browser tab
      window.open(blobUrl, '_blank');
      
    } catch (error) {
      console.log(error);
    }
    finally {setFetchingPreview(false); handleClosePreviewDialog();}

  }

  return  <div className='flex justify-center'>
  <CcActionButton className="mt-2" type="button" onClick={getWebPagePreview} >Preview web page</CcActionButton>

  <Dialog
        fullWidth
        maxWidth="lg"
        open={openPreviewDialog}
        onClose={handleClosePreviewDialog}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className='p-1 h-[800px] overflow-auto'>
          {fetchingPreview && <div className='flex justify-center mt-48'>
                <CcLoader size={96} />
                </div>
          }
          {!fetchingPreview && <div className=''>
                <iframe className='w-full' srcDoc={previewHtml} sandbox="allow-scripts allow-same-origin" title='Preview'></iframe>
                </div>
          }
          
        </div>
        <DialogActions>
          <CcActionButton className='mr-2 mb-2' onClick={handleClosePreviewDialog}>Close</CcActionButton>
        </DialogActions>
      </Dialog>

</div>

}

export default function MemoryCardsWorkflow(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();

    const confettiDefaultColors = ['#ff0000', '#00ff00', '#0000ff', '#ff00ff', '#ffff00', '#00ffff', '#ff8800', '#8800ff'];

    const [snippetData, setSnippetData] = useState({snippetName: '', snippetDesc: '', 
                  webPageSettings: {coverAddEffect: false, confettiAddEffect: false, confettiColors: confettiDefaultColors, selectedWebPageId: 4, templatePropValuesCollection: [], coverType: 'solidColor', ctaButtonCorners: 'rounded', coverSolidColor: '#b3b3b3', expiryDate: dayjs().add(24, 'hour').toJSON(), expiryTimezoneId: 'Europe/London', href: '' },
                  snippetSettings: {cardImages: [{imgB64: ''}], emailEffectType: 'static', emailEffectStaticImg: '', emailEffectImgSize: {width: 600, height: 400}, emailEffectImg: [], numCardsInEmailEffectImg: 0, emailEffectCustomBackground: '' }});


    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [generatingPreview, setGeneratingPreview] = useState(false)
    const [teaserPreview, setTeaserPreview] = useState('')
    const [partialRevealPreviews, setPartialRevealPreviews] = useState([''])

    const [activeErrorList, setActiveErrorList] = useState([]);
    const [effectImageSizeUI, setEffectImageSizeUI] = useState(undefined) //only used in the UI, it contains the size of the email image
    const [prePopulateWebPageMsg, setPrePopulateWebPageMsg] = useState(true) // UI only,

    const elementManagerRef = useRef();
    //const elementWebPageManagerRef = useRef()

    let params = useParams();
    useEffect(() => {
      if (params.snippetId !== undefined) {
        getSnippetInfo(params.snippetId)
      }
    }, [props.snippetId])

    const getSnippetInfo = async (snippetId) => {
      
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
        const response = await axios.get(url);

        const newSnippetData = response.data;
        newSnippetData.snippetSettings = JSON.parse(response.data.snippetSettings);
        newSnippetData.webPageSettings = JSON.parse(response.data.webPageSettings);
        //console.log(newSnippetData.snippetSettings)
        //console.log(newSnippetData.webPageSettings)
        //adding new metadata for compatibility with old tags that don't have it
        if (newSnippetData.webPageSettings.confettiColors === undefined) newSnippetData.webPageSettings.confettiColors = confettiDefaultColors;
        const ctaBtnCorners = newSnippetData.webPageSettings.templatePropValuesCollection.find(pv => pv.propName === 'cta-border-radius')
        if (ctaBtnCorners === undefined) newSnippetData.webPageSettings.templatePropValuesCollection.push({propName: 'cta-border-radius', propValue: 'rounded'})
        setSnippetData(newSnippetData)


      } catch (error) {
        console.log(error);
      }
      
    }

    const submitDataSnippet = async () => {

      setShowLoader(true);
      setSuccessHtmlMsg('');
    
      try {
          let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/22`;
          if (params.snippetId !== null && params.snippetId !== undefined) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/22/${params.snippetId}`;

          const snippetSettingsToPost = {...snippetData.snippetSettings}
          if (snippetData.snippetSettings.emailEffectType === 'gameScreenshot') {
            const img = await elementManagerRef.current.askImage(effectImageSizeUI);
            snippetSettingsToPost.emailEffectImg = [img];
            snippetSettingsToPost.emailEffectImgSize = effectImageSizeUI
          }
          if (snippetData.snippetSettings.emailEffectType === 'gameAnimation') {
            const img = await elementManagerRef.current.askFrames(effectImageSizeUI);
            snippetSettingsToPost.emailEffectImg = img;
            snippetSettingsToPost.emailEffectImgSize = effectImageSizeUI
          }

          console.log(snippetSettingsToPost)
          const dataToPost = {...snippetData, href: '', snippetSettings: JSON.stringify(snippetSettingsToPost), 
                              webPageSettings: JSON.stringify(snippetData.webPageSettings)}

          const response = await axios.post(url, dataToPost);
    
          setSuccessHtmlMsg(response.data);
          setShowSuccessMsg(true);
      } catch (error) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
        console.log(error);
      }
      setShowLoader(false);
      setSubmitted(true)

      return true;
    }
  const handleElementChange = (snippetInfo) => {
    //console.log(snippetInfo)
    setSnippetData(snippetInfo)

    if (activeErrorList.length > 0) {
      try {
        snippetDataValidationSchemaMemoryCards.validateSync(snippetInfo, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }
  }
  const handleElementSnippetSettingsChange = (snippetSettings) => {
    //console.log(snippetSettings)
    const newSettings = {...snippetData, snippetSettings: snippetSettings}
    setSnippetData(newSettings)
    //setPartialRevealPreviews(Array(snippetSettings.revealImages.length).fill(''));


    if (activeErrorList.length > 0) {
      try {
        snippetDataValidationSchemaMemoryCards.validateSync(newSettings, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }
  }
  const handleElementWebPageChange = (settings) => {
    const newSettings = {...snippetData, webPageSettings: settings}
    //console.log(newSettings)
    setSnippetData(newSettings)
    setPrePopulateWebPageMsg(false)

    if (activeErrorList.length > 0) {
      try {
        webPageSettingsValidationSchemaMemoryCards.validateSync(settings, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }

  }
  const handleRevealImagesChange = (newRevealImages) => {
    const newSnippetSettings = {...snippetData.snippetSettings, revealImages: newRevealImages}
    const newSettings = {...snippetData, snippetSettings: newSnippetSettings}
    //console.log(newSettings)
    setSnippetData(newSettings)
  }

  const handleNavChange = async(navInfo) => {
    if (navInfo.actionType === 'Navigation'){
      //if we are moving from 0 to 1 we need to apply some validation
      if (currentStep === 0 && navInfo.nextIndex === 1) {
        try {
          //console.log(snippetData)
          snippetDataValidationSchemaMemoryCards.validateSync(snippetData, {abortEarly: false});
          setActiveErrorList([])
        }
        catch (e) {
          //console.log(JSON.parse(JSON.stringify(e)))
          const errorList = getErrorListFromYupError(e)
          //legacy issue: yup can return also href errors that we don't validate anymore
          // in this step. We need to supress this error here
          const hrefErrorIndex = errorList.findIndex(e => e.fieldName === 'snippetSettingsRevealHref');
          if (hrefErrorIndex !== -1) errorList.splice(hrefErrorIndex, 1);
          
          
          console.log(errorList)
          setActiveErrorList(errorList)
          if (errorList.length > 0) return false;
        }    
      }
      if ((currentStep === 1 && navInfo.nextIndex === 2) || (currentStep === 1 && navInfo.nextIndex === 0)) {
        try {
          //console.log(snippetData.webPageSettings)
          webPageSettingsValidationSchemaMemoryCards.validateSync(snippetData.webPageSettings, {abortEarly: false});
          setActiveErrorList([])
        }
        catch (e) {
          // IF VALIDATION IS NO PASSED WE RETURN AND DO NOTHING ELSE

          //console.log(JSON.parse(JSON.stringify(e)))
          const errorList = getErrorListFromYupError(e)
          setActiveErrorList(errorList)
          return;
        }

        /* MOVE TO SUBMIT
        if (snippetData.snippetSettings.emailEffectType === 'coverAndTeaser') {
          const pointerInfo = await elementManagerRef.current.askPointerImg()
          const newSnippetSettings = {...snippetData.snippetSettings, pointerB64: pointerInfo.b64, pointerXml: pointerInfo.pointerXml}
          const newSettings = {...snippetData, snippetSettings: newSnippetSettings}
          setSnippetData(newSettings)  
        }
        else if (snippetData.snippetSettings.emailEffectType === 'coverAndPartialReveal') {
          const brushProps = await elementManagerRef.current.askBrushB64()
          const newSnippetSettings = {...snippetData.snippetSettings, partialRevealSettings: brushProps}
          const newSettings = {...snippetData, snippetSettings: newSnippetSettings}
          setSnippetData(newSettings)  
          console.log(newSettings)
        }
        */
      }
      if (currentStep === 2 && navInfo.nextIndex === 1) {
        //when moving back from 2 to 1 we want to update the emailEffectImgSize
        const newSettings = {...snippetData, snippetSettings: {...snippetData.snippetSettings, emailEffectImgSize: effectImageSizeUI}}
        setSnippetData(newSettings)

        //emailEffectImgSize
      }
      setCurrentStep(navInfo.nextIndex);
    }
    else if (navInfo.actionType === 'Submit') {

      //if we are here then the validastion is passed
      setCurrentStep(navInfo.nextIndex);
      submitDataSnippet()
      
    }
  }
    
    const handleClose = () => {
        navigate("/ph/memoryCards")
    }
    

    const [openPreviewTeaser, setOpenPreviewTeaser] = useState(false);
    const handleClosePreviewTeaser = () => {
      setOpenPreviewTeaser(false)
      setPartialRevealPreviews(partialRevealPreviews.fill(''))
      setTeaserPreview('')
    }

    const handleRequestPointerB64 = async () => {
      //const result = await elementWebPageManagerRef.current.askPointerImg();

      //return result.b64
    }
    const handleEffectImgSizeChange = (newSize) => {
      setEffectImageSizeUI(newSize)
    }

    const getTeaserAnimation = async () => {
      try {
        setGeneratingPreview(true)
        setOpenPreviewTeaser(true)
        setTeaserPreview('')

  
        let url = `${process.env.REACT_APP_LION_API_URL}/Animations/memoryGame/getTeaser`;

        const frames = await elementManagerRef.current.askFrames(effectImageSizeUI);
        const dataToPost = {frames: frames}

        //const dataToPost = {frames: snippetData.snippetSettings.emailEffectImg}
  
        const response = await axios.post(url, dataToPost);
        //console.log(response.data)
  
        setTeaserPreview(response.data)
  
    } catch (error) {
      //console.log(error)
    }
    finally {setGeneratingPreview(false)}
  
    }
    const getPreviewEmail = async () => {
      setTeaserPreview('')
      //setPartialRevealPreviews(Array(snippetData.snippetSettings.revealImages.length).fill(''));
      getTeaserAnimation()
    }

    return <div>
        <CcStepper2
            steps={[{ name: 'Assets', href: '#' },
                    { name: 'Game', href: '#' },
                    { name: 'Cover', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]}
            currentStepIndex={currentStep}
        />
        <div className="border border-2 border-gray-200 rounded-md p-2">

            {currentStep === 0 && <MemoryCardsAssetsManager
                                    onChange={handleElementChange}
                                    validationErrorsList={activeErrorList}
                                    snippetInfo={snippetData}
              />}
            {currentStep === 1 && <>
              <MemoryCardsWebPageManager
                                    onChange={handleElementWebPageChange}
                                    onChangeRevealImages={handleRevealImagesChange}
                                    snippetInfo={snippetData}
                                    validationErrorsList={activeErrorList}
                                    prePopulateMsg={prePopulateWebPageMsg}
                                    //ref={elementWebPageManagerRef}
              />
              <WebPagePreviewer 
                                    snippetInfo={snippetData}
                                    onRequestPointerB64={handleRequestPointerB64}
              />
            </>

            }
            {currentStep === 2 && <><MemoryCardsEmailManager
                                    onChange={handleElementSnippetSettingsChange}
                                    validationErrorsList={activeErrorList}
                                    snippetInfo={snippetData}
                                    onCanvasSizeChange={handleEffectImgSizeChange}
                                    ref={elementManagerRef}
              />
              {snippetData && snippetData.snippetSettings.emailEffectType === 'gameAnimation' &&
                  <div className='flex justify-center'>
                  <CcActionButton className="mt-2" type="button" onClick={getPreviewEmail} >Preview</CcActionButton>
                </div>
              }
            </>
            }

            {currentStep === 3 && <div className='flex flex-col items-center'>
                <MemoryCardsEmailManager noRender
                                      snippetInfo={snippetData}
                                      ref={elementManagerRef}
                />
                {!showLoader && !showSuccessMsg && !showErrorMsg && <div>Confirm</div> }
                {showLoader && <div className='py-12'><CcLoader size={96} /></div> }
                {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}
                {(showSuccessMsg || showErrorMsg) && <div> <CcActionButton variant="contained" onClick={handleClose} >Close</CcActionButton></div>}
            </div>}

            {currentStep !== 3 &&
                    <StepperNavButtons totalSteps={4}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />
            }
        </div>

        <Dialog
        fullWidth
        maxWidth="lg"
        open={openPreviewTeaser}
        onClose={handleClosePreviewTeaser}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className='flex items-end'>
          <div className='flex grow'></div>
          <IconButton sx={{m:1}} onClick={handleClosePreviewTeaser}><Iconify icon={lionIcons.Icon_Actions_Cancel} width={40} /></IconButton>
        </div>

        <div className='flex flex-col items-center justify-center text-ccColorDarkTeal font-poppins'>
          <div className=' text-3xl  font-bold m-3'>{"Preview"}</div>
            <div className='w-[800px] h-2'></div>
            <>
              {generatingPreview &&  
                    <div className=''><CcLoader size={128} /></div>
              }
              {teaserPreview.length > 0 && <div className='w-[800px] h-[650px]'>
                  <div className='relative h-full' >
                    <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`data:image;base64,${teaserPreview}`} alt='' />
                  </div>
                </div>
              }            
            </>
            
        </div>
{/*
        <DialogActions>
          <CcActionButton className='mr-2 mb-2' onClick={handleClosePreviewTeaser}>Close</CcActionButton>
        </DialogActions>

*/}
      </Dialog>

    </div>
}